import Layout from "../../components/Layout";
import AdminCollectionTable from "../../components/AdminCollectionTable";

// Format an ISO / Mongo ISODate string as "dd MMM yyyy HH:mm" (UK)
const formatDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("en-GB", { month: "short" });
  const year = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${day} ${month} ${year} ${hh}:${mm}`;
};

const formatText = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return String(v);
};

// Direction chip colouring
const formatDirection = (v) => {
  if (!v) return "—";
  return String(v);
};

const COLUMNS = [
  { key: "created_date",  label: "Created",     path: "CreatedDate",                    sortable: true, sortPath: "CreatedDate", formatter: formatDateTime },
  { key: "direction",     label: "Direction",   path: "JCCall.data.call_info.direction", sortable: true, sortPath: "JCCall.data.call_info.direction", formatter: formatDirection },
  { key: "type",          label: "Type",        path: "JCCall.data.call_info.type",     sortable: true, sortPath: "JCCall.data.call_info.type", formatter: formatText },
  { key: "agent",         label: "Agent",       path: "JCCall.data.agent_name",         sortable: true, sortPath: "JCCall.data.agent_name", formatter: formatText },
  { key: "contact_name",  label: "Contact",     path: "JCCall.data.contact_name",       sortable: true, sortPath: "JCCall.data.contact_name", formatter: formatText },
  { key: "contact_num",   label: "Number",      path: "JCCall.data.contact_number",     sortable: false, formatter: formatText },
  { key: "brand",         label: "Brand (IVR)", path: "JCCall.data.ivr_info.content",   sortable: true, sortPath: "JCCall.data.ivr_info.content", formatter: formatText },
  { key: "duration",      label: "Duration",    path: "JCCall.data.call_duration.friendly_duration", sortable: false, formatter: formatText },
  { key: "sentiment",     label: "Sentiment",   path: "JCCall.data.justcall_ai.customer_sentiment",  sortable: true, sortPath: "JCCall.data.justcall_ai.customer_sentiment", formatter: formatText },
  { key: "assigned_to",   label: "Assigned To", path: "AssignedTo",                     sortable: true, sortPath: "AssignedTo", formatter: formatText },
];

export default function CallManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="calls"
        title="Calls"
        subtitle="JustCall Call Records"
        columns={COLUMNS}
      />
    </Layout>
  );
}
